import React, { useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import './Assetes/Style.css'
import './Assetes/MediaQuery.css'
import 'remixicon/fonts/remixicon.css'
import 'remixicon/fonts/remixicon.css'
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from 'react-redux';
import store, { persistor } from './Redux/store';
import AppRoutes from './Routes';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useLocation } from 'react-router-dom';
import PathName from './Routes/RoutePath';
import { mergnActivate } from './utils/mergn';
import { MERGN_ACTIVATE } from './constants';
import "./i18";
import { useTranslation } from 'react-i18next';
import { GoogleMapsProvider } from './providers/GoogleMapProvider';

// new commit
function App() {
  const location = useLocation();
  
  const { pathname } = location;
  useEffect(() => {
    if (pathname !== PathName.MobilePaymentMethod && "geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition((position: any) => {
        sessionStorage.setItem("lat", position.coords.latitude)
        sessionStorage.setItem("lng", position.coords.longitude)
      })
    }
  }, [])

  useEffect(() => {
    console.log(`${MERGN_ACTIVATE ?  "✅ Mergn Activated" : "❌ Mergn Disabled"}`);
    if(MERGN_ACTIVATE) {
      mergnActivate();
    }
  }, [])

  const { i18n } = useTranslation();

  useEffect(() => {
    const currentLang = i18n.language;
    const direction = currentLang === "ar" ? "rtl" : "ltr";
    document.documentElement.setAttribute("dir", direction);
    document.documentElement.setAttribute("lang", currentLang);
    document.documentElement.setAttribute("class", currentLang);
  }, [i18n.language]);

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <GoogleMapsProvider>
          <ToastContainer />
          <AppRoutes />
        </GoogleMapsProvider>
      </PersistGate>
    </Provider>
  );
}

export default App;